import { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Spinner, Divider, Dropdown, DropdownOption, DropdownSelectAllOption, Typography } from "@volvo/vcdk-react";
import { MultiDropdownChangeEvent } from "@volvo/vcdk";
import { useGetDistinctContractTypesQuery } from '../../../store/InvoiceApiSlice';

export const ContractDropdown = forwardRef((props, ref) => {    

    const [contractList, setContractList] = useState<Array<{name: string, selected: boolean}>>([]);
    const {data: typeList = [], isLoading, isSuccess, isError, error} = useGetDistinctContractTypesQuery({});
    const [valid, setValid] = useState(true);

    useImperativeHandle(ref, () => ({
        getSelectedContracts: () => {
            const selectedContracts = contractList.filter(contract => contract.selected).map(contract => contract.name);
            if(selectedContracts.length === 0) setValid(false);
            return selectedContracts;
        },
        getUnselectedContracts: () => contractList.filter(contract => !contract.selected).map(contract => contract.name),        
    }));

    useEffect(() => {
        if(isSuccess){
            setContractList(typeList.map((type: string) => ({ 
                name: type, 
                selected: type === 'VTC-Up-front' || type.toLowerCase().startsWith('vce') || type.toLowerCase().startsWith('sold') ? true : false
            })));
        }
    }, [isSuccess, typeList]);
    
    const onChange = (e: MultiDropdownChangeEvent) => {
        if(!valid) setValid(true);
        setContractList(prevState => prevState.map(contract => ({
            ...contract,
            selected: e.detail.findIndex(x => x.value === contract.name) > -1
        })));
    }
    if(isLoading) return <Spinner />
    return (<div style={{ height: 60, overflowY: 'auto' }}>
        <Typography variant="subtitle2" style={{ color: valid ? "#575757" : "#BF2012" }}>Client contract type</Typography>        
        <Dropdown value={contractList.filter(contract => contract.selected).map(contract => contract.name)} floatingLabel={false} size='small' multi={true} onChange={onChange}>
            <DropdownSelectAllOption selected={contractList.every(contract => contract.selected) ? "checked" : (contractList.length === 0 || contractList.every(contract => !contract.selected) ? "unchecked" : "indeterminate")}>Select All</DropdownSelectAllOption>
            <Divider />
            {contractList.map((contract: {name: string, selected: boolean}) => (
                <DropdownOption key={`contract-type-${contract.name}`} selected={contract.selected}>
                    {contract.name}
                </DropdownOption>
            ))}
        </Dropdown>
    </div>)
})